<template>
	<div class="main" v-title data-title="零部件首页">
		<iHeader :title="titleDec" ref="loginIndex"></iHeader>
		<div class="elbgt">
			<el-row class="barprebox">
				<el-col :span="5">
					<div class="w350 filelist dsfl">
						目录分类
					</div>
				</el-col>
				<el-col :span="14">
					<!-- w810  -->
					<div class="font16">
						<div class="mulu" style="">
							<el-row class="el-rowlizi">
								<el-col :span="4">
									<el-link href="/list/catelist?cateid=1" target="_blank">零件库</el-link>
								</el-col>
								<el-col :span="4">
									<el-link href="/list/catelist?cateid=88" target="_blank">标准件库</el-link>
								</el-col>
							<!--	<el-col :span="4">
									<el-link href="#" target="_blank">数字营销</el-link>
								</el-col>
								<el-col :span="4">
									<el-link href="#" target="_blank">合作厂商</el-link>
								</el-col>-->
								<el-col :span="4">
									<el-link href="/notice/vipmember" target="_blank">开通会员</el-link>
								</el-col>
							<!--	<el-col :span="4">
									<el-link href="#" target="_blank">选型小工具</el-link>
								</el-col>-->
							</el-row>
						</div>
					</div>
				</el-col>
				<!-- <el-col :span="7">
					<div class="w290 mulu font16 fr">
						<el-row>
							<el-col :span="12">
								<el-link href="https://element.eleme.io" target="_blank">我要分享</el-link>
							</el-col>
							<el-col :span="12">
								<el-link href="https://element.eleme.io" target="_blank">内容贡献者</el-link>
							</el-col>
						</el-row>
					</div>
				</el-col> -->
			</el-row>
		</div>
		<!-- 分类效果 -->
		<div class="barprebox clearfix max1350 mtb30">
			<div class="panCate curhand">
				<!-- class="iconfont icon-switch" :id="`icon_${index}`" -->
				<div class="maintip " @mouseover="cateaddload($event,index)" @mouseout="cateremoveload($event,index)" v-for="(item,index) in partone" :key="index">
					<span class="pdl20 overtitleOne lin-h41" :id="`pdid_${index}`" @click="jumpcate(item.id,item.title)">
						<i :class="item.id | classFilter"></i>
						{{item.title}}
					</span>
					<div class="tips flexRow" :id="`tips_${index}`">
						<el-row :gutter="20">
							<el-col :span="12" v-for="(Citem,index) in item.son" :key='index'>
								<div class="txl bold font16 border-b pdb10 curhand" @click="jumpcate(Citem.id,item.title)">{{Citem.title}}</div>
								<div class="mt10">
									<!-- <el-link>光轴</el-link>
									<el-link>异形轴</el-link>
									<el-link>一端锥形轴</el-link>
									<el-link>一端台阶轴</el-link>
									<el-link>两端台阶轴</el-link>
									<el-link>二级台阶轴</el-link>
									<el-link>双内螺纹轴</el-link>
									<el-link>一端内螺纹轴</el-link>
									<el-link>两端内螺纹轴</el-link>
									<el-link>一端外螺纹轴</el-link>
									<el-link>两端外螺纹轴</el-link>
									<el-link>内六角孔型轴</el-link>
									<el-link>特殊端面加工轴</el-link> -->
								</div>
							</el-col>
						</el-row>
						<div style="position: relative;bottom: -80px">
							<el-row class="lookD" :gutter="20">
								<el-col v-for="(item,index) in item.product.list" :key="index" style="width: 20%;">
									<div class="colDP curhand" @mousemove="addClasshistory($event)" @mouseout="removeClasshistory($event)" @click="jumpurl(item.id)">
										<span class="coldS">
											<el-image :src="'https://images.mfcad.cn/goods/2020/12/10/b01f77d7-560d-4477-a01e-699844b53048.png'"
											 fit="cover"></el-image>
										</span>
										<div class="colDPimg mt10">
											<p class="overtitleOne bold">{{item.title}}</p>
											<p class="col-666 overtitleOne">{{item.catname}}</p>
										</div>
									</div>
								</el-col>
							</el-row>
						</div>
					</div>
				</div>

			</div>
			<div class="panRig">
				<el-row :gutter="10" style="margin-right: 0;">
					<el-col :xs="17" :sm="17" :md="12" :lg="17" :xl="17" style="padding-left: 5px; padding-right: 0px;">
						<el-carousel :interval="3000" arrow="always" class="swiper1" >
							<el-carousel-item v-for="(item,index) in bannerlist" :key="index">
								<el-link :href="item.url" target="_blank"><img :src="item.src" alt="" style="width: 100%;"></el-link>
							</el-carousel-item>
						</el-carousel>
					</el-col>
					<el-col :xs="7" :sm="7" :md="10" :lg="7" :xl="7" style="padding-left: 15px;padding-right: 0px;">
						<div class="RigP1">
							<P class="Rigt">欢迎光临沐风网</P>
							<el-row :gutter="10" v-if="loginFlag==true">
								<el-col :span="12" class="RigLS"><i class="iconfont icon-dengluyonghu"></i><span @click="handChild">登录</span></el-col>
								<el-col :span="12" class="RigLS"><i class="iconfont icon-yuzhuceqiye"></i><span @click="handChild">注册</span></el-col>
							</el-row>
							<el-row :gutter="10" v-else>

								<!-- <img src="https://www.mfcad.cn/image/loading/1.jpg" alt="" style="width: 25px; height: 25px;"> -->
								<!-- <el-image :src="userImg" fit="contain" style="width:25px; height: 25px;"></el-image> -->
								<el-col :span="5" class="RigLS"><img :src="userImg" alt="" style="width: 35px; height: 35px; margin-left: 15px;"></el-col>
								<el-col :span="18" class="RigLS" style="text-align: left;">
									<!-- <img src="../../assets/index/swiper.jpg" alt=""> -->
									<p>欢迎您!{{username}}</p>
									<a href="/people/baseinfo" class="ahover mt10" style="color: #005dbe;display: block;">个人中心</a>
									<!-- <p>{{userImg}}</p> -->
								</el-col>
							</el-row>
						</div>
						<div class="RigP2">
							<el-tabs v-model="activeName" type="card" @tab-click="handleClick" :stretch='true'>
								<el-tab-pane label="我的下载" name="first" v-if="loginFlag==false">
									<el-row>
										<el-col :span="12">
											<el-link :underline="false" icon="iconfont icon-liulanjilu mr10" href='/people/history' target="_blank">浏览历史</el-link>
										</el-col>
										<el-col :span="12" style="text-align: right;">
											<el-link :underline="false" icon="iconfont icon-ziyuan mr10" href='/people/download' target="_blank">下载记录</el-link>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="12">
											<el-link :underline="false" icon="iconfont icon-shoucang mr10" href='/people/collection' target="_blank">收藏夹</el-link>
										</el-col>
										<el-col :span="12" style="text-align: right;">
											<el-link :underline="false" icon="iconfont icon-gonggao mr10" href='/people/myinfo' target="_blank">我的消息</el-link>
										</el-col>
									</el-row>
								</el-tab-pane>
								<el-tab-pane label="我的下载" name="first" v-else-if="loginFlag==true">
									<el-row>
										<el-col :span="12">
											<el-link :underline="false" icon="iconfont icon-liulanjilu mr10" @click="HandeJumpP('people/history')">浏览历史</el-link>
										</el-col>
										<el-col :span="12" style="text-align: right;">
											<el-link :underline="false" icon="iconfont icon-ziyuan mr10" @click="HandeJumpP('people/download')">下载记录</el-link>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="12">
											<el-link :underline="false" icon="iconfont icon-shoucang mr10" @click="HandeJumpP('people/collection')">收藏夹</el-link>
										</el-col>
										<el-col :span="12" style="text-align: right;">
											<el-link :underline="false" icon="iconfont icon-gonggao mr10" @click="HandeJumpP('people/myinfo')">我的消息</el-link>
										</el-col>
									</el-row>
								</el-tab-pane>
								<el-tab-pane label="我的发布" name="second" v-if="loginFlag==false">
									<el-row>
										<el-col :span="12">
											<el-link :underline="false" icon="iconfont icon-ziyuan mr10" href='/people/approve' target="_blank">下载记录</el-link>
										</el-col>
										<el-col :span="12" style="text-align: right;">
											<el-link :underline="false" icon="iconfont icon-chanpinguanli1 mr10" @click="HandeJumpL('hou')">产品管理</el-link>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="12">
											<el-link :underline="false" icon="iconfont icon-fabu mr10" @click="HandeJumpL('hou')">发布产品</el-link>
										</el-col>
										<el-col :span="12" style="text-align: right;">
											<el-link :underline="false" icon="iconfont icon-info-1-copy mr10" @click="HandeJumpL('hou')">信息维护</el-link>
										</el-col>
									</el-row>
								</el-tab-pane>
								<el-tab-pane label="我的发布" name="second" v-else-if="loginFlag==true">
									<el-row>
										<el-col :span="12">
											<el-link :underline="false" icon="iconfont icon-shanghupiliangruzhu mr10" @click="HandeJumpP('people/approve')">申请入驻</el-link>
										</el-col>
										<el-col :span="12" style="text-align: right;">
											<el-link :underline="false" icon="iconfont icon-chanpinguanli1 mr10" @click="HandeJumpL('hou')">产品管理</el-link>
										</el-col>
									</el-row>
									<el-row>
										<el-col :span="12">
											<el-link :underline="false" icon="iconfont icon-fabu mr10" @click="HandeJumpL('hou')">发布产品</el-link>
										</el-col>
										<el-col :span="12" style="text-align: right;">
											<el-link :underline="false" icon="iconfont icon-info-1-copy mr10" @click="HandeJumpL('hou')">信息维护</el-link>
										</el-col>
									</el-row>
								</el-tab-pane>
							</el-tabs>
						</div>
						<div class="RigP3">
							<p class="font14 Cred" style="padding-top: 10px;"><i class="iconfont icon-gonggao"></i>动态公告 <span @click="jumpnotice(1)"
								 class="fr curhand col-999">更多>></span></p>
							<el-link :underline="false" @click="jumpnotice(2,item.id)" v-for="(item,index) in gglist" :key="index" class="overtitleOne mt5"
							 style="text-align: left;">
								<span class="mr20 ">{{item.create_time}}</span>
								{{item.title}}
							</el-link>
						</div>
					</el-col>
				</el-row>
				<div class="brandP" style="height: 215px;">
					<p class="brandT pdl8">认证品牌</p>
					<el-row :gutter="20" class="hander">
						<el-col :span="6" v-for="(item,index) in company" :key="index" style="margin-top: 5px; height: 86px;cursor: pointer;">
							<!--  @click="handCjump('company/icompany',item.userid)" -->
							<div>
								<div class="inlinI"  @click="handCjump('company/icompany',item.userid)" >
									<el-image :src="item.image" fit="contain" style="width: 221px; height: 60px;" onerror='this.src="https://www.mfcad.cn/image/loading/384180.jpg"'></el-image>
								</div>
								<p class="font12 mt10 col-666">{{item.company}}</p>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>
		<!-- 分类结束 -->
		<div class="barprebox max1350">
			<div class="brandP" style="padding-bottom: 20px;">
				<el-row class="bgwhite" :gutter="20">
					<el-col :span="13" style="padding-right: 40px;">
						<p class="brandT pdb10">浏览历史</p>
						<el-row class="lookD" :gutter="20">
							<el-col :span="6" v-for="(item,index) in hislist" :key="index">
								<div class="colDP curhand" @mousemove="addClasshistory($event)" @mouseout="removeClasshistory($event)" @click="jumpurl(item.id,item.is_guobiao)">
									<span>
										<el-image :src="'https://images.mfcad.cn/'+item.thumb"
										 fit="cover"></el-image>
									</span>
									<div class="colDPimg mt10">
										<!-- <p class="Cred">¥ 5.19起</p> -->
										<p class="overtitleOneA bold">{{item.title}}</p>
										<p class="col-666 overtitleOneA">{{item.catname}}</p>
									</div>
								</div>
							</el-col>
						</el-row>
					</el-col>
					<el-col :span="11">
						<p class="brandT pdb10">猜你喜欢</p>
						<el-row class="lookD" :gutter="20">
							<el-col :span="8" v-for="(item,index) in likelist" :key="index">
								<div class="colDP curhand" @mousemove="addClasslike($event)" @mouseout="removeClasslike($event)" @click="jumpurl(item.id,item.is_guobiao)">
									<span>
										<el-image :src="'https://images.mfcad.cn/'+item.thumb" fit="cover"></el-image>
									</span>
									<div class="colDPimg mt10">
										<!-- <p class="Cred">¥ 5.19起</p> -->
										<p class="overtitleOne bold">{{item.title}}</p>
										<p class="col-666 overtitleOne">{{item.catname}}</p>
									</div>
								</div>
							</el-col>
							<!-- <el-col :span="8">
								<div class="colDP">
									<div class="colDPimgR">
										<p class="col-666 font12">经济型联轴器新上市</p>
										<p class="font14 bold">最低未税27.42元起性价比之选</p>
									</div>
									<span>
										<el-image :src="'https://images.mfcad.cn/goods/2020/11/4/7d33a4e8-3c08-4e9f-9118-b92fd43e5b26.png'"
										 fit="cover"></el-image>
									</span>
								</div>
							</el-col> -->
						</el-row>
					</el-col>
				</el-row>
			</div>
		</div>
		<!-- 您可能需要的零部件 -->
		<div class="barprebox bgwhite par-lr-15 clearfix max1350 mtb30" v-for="(items,index) in category_list" :key="index">
			<div class="limtit mdb10">
				<div class="fl bold">{{items.catename}}
					<p class="mt5 goodsHover">
						<el-link :underline="false" v-for="(item,index) in items.category_list" :key="index" target="_blank" class=" mr10 curhand"
						 @click="jumpcate(item.id,item.title)">{{item.title}}</el-link>
					</p>
				</div>
			</div>
			<div class="barprebox clearfix max1350 mtb30">
				<div class="pdb30 pd25Left">
					<div class="demo-image curhand">
						<div class="block blockInfo wpro" v-for="(item,index) in items.product_list" :key="index" @mousemove="addClassload($event)"
						 @mouseout="removeClassload($event)" @click="jumpurl(item.id)" :title="item.title">
							<el-image style="width: 190px; height: 190px" :src="'https://images.mfcad.cn/'+item.thumb"
							 fit="cover" @mousemove="ImgaddClassload($event)" @mouseout="ImgremoveClassload($event)"></el-image>
							<div class="font14 fl mt10 bold overtitleOne" style="width: 100%;">{{item.title}}</div>
							<div class="font14 fl overtitle col-666" style="width: 100%;">{{items.catename}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<v-footer></v-footer>
	</div>
</template>
<script>
	import iHeader from "@/components/indexheader"
	import vFooter from "@/components/Footer"
	import "@/assets/cont-01.css";
	import Vue from 'vue';
	import axios from 'axios';
	Vue.prototype.$axios = axios;
	export default {
		components: {
			vFooter,
			iHeader,
		},
		data() {
			return {
				titleDec: "",
				partone: [],
				company: [],
				datalist: [],
				category_list: [],
				product1: [],
				product2: [],
				product3: [],
				Ginfo: [],
				activeName: 'first',
				// 公告
				gglist: [],
				// 浏览历史
				hislist: [],
				// 猜你喜欢
				likelist: [],
				// 父组件调用子组件
				username: '',
				loginFlag: true,
				userImg: '',
				bannerlist:[
					{src:'https://static.mfcad.com/lingbujian/pc-img/pcbanner.jpg',url:'/notice/vipmember'},
					{src:'https://static.mfcad.com/lingbujian/pc-img/pcbanner1.png'}
				]
			};
		},
		filters: {
			classFilter(i) {
				if (i > 37) {
					return 'iconfont icon-cateiconOther';
				} else if (i > 0 && i <= 36) {
					return 'iconfont icon-cateicon' + i;
				}
			}
		},
		created() {
			this.handeLogin();
			this.partssort();
			this.product();
			// 最近更新的模型
			this.handNewcate();
			// 公告消息
			this.handgg();
			// 浏览历史
			this.handhistory();
			// 猜你喜欢
			this.handlike()
			// 最新加入的企业
			this.enterprise()
			// 分类菜单添加icon

		},
		methods: {
			handeLogin(){
				setTimeout(() => {
					if (this.$refs.loginIndex.loginFlag == false) {
						this.loginFlag = false
						this.username = this.$refs.loginIndex.username
						this.userImg = this.$refs.loginIndex.userImg;
						// this.auth=this.$refs.loginIndex.auth;
					} else {
						this.loginFlag = true;
					}
				}, 2000)
			},
			// 登录注册
			handChild() {
				this.$refs.loginIndex.handLogin('')
			},
			// 跳转个人中心
			HandeJumpP(url) {
				this.$refs.loginIndex.handLogin(window.location.href + url)
				// this.$message({
				// 	type: 'info',
				// 	message: '请您先进行登录操作!'
				// });
			},
			HandeJumpL(houUrl) {
				if (this.$refs.loginIndex.auth == "未认证") {
					let routeData = this.$router.resolve({
						name: "approve",
					})
					window.open(routeData.href, '_blank');
				} else {
					this.$refs.loginIndex.Handehoutai();
				}
			},
			// 公告跳转
			jumpnotice(type, id) {
				if (type == 2) {
					let routeData = this.$router.resolve({
						name: "noticeinfo",
						query: {
							goodsid: id
						}
					})
					window.open(routeData.href, '_blank');
				} else {
					let routeData = this.$router.resolve({
						name: "noticelist",
					})
					window.open(routeData.href, '_blank');
				}
			},
			handCjump(url,id){
				let routeData = this.$router.resolve({
					path: url,
					query: {
						cid: id
					}
				})
				if(this.loginFlag===false){
					window.open(routeData.href, '_blank');
				}else if(this.loginFlag===true){
					this.$refs.loginIndex.handLogin(window.location.href + url)
				}
			},
			handleClick(tab, event) {
			},
			addClassload($event) {
				$event.currentTarget.className = "block blockInfo active";
			},
			removeClassload($event) {
				$event.currentTarget.className = "block blockInfo";
			},
			ImgaddClassload($event) {
				$event.currentTarget.className = "el-image__inner Wactive";
			},
			ImgremoveClassload($event) {
				$event.currentTarget.className = "el-image__inner";
			},
			addClasshistory($event) {
				$event.currentTarget.className = "colDP curhand active";
			},
			removeClasshistory($event) {
				$event.currentTarget.className = "colDP curhand";
			},
			addClasslike($event) {
				$event.currentTarget.className = "colDP curhand active";
			},
			removeClasslike($event) {
				$event.currentTarget.className = "colDP curhand";
			},
			cateaddload($event, index) {
				$event.currentTarget.className = "maintip Cactive";
				$('#pdid_' + index).addClass('pdl20 colWhite');
				$('#tips_' + index).addClass('tipRemove');
			},
			cateremoveload($event, index) {
				$('#tips_' + index).removeClass('tipRemove');
				$('#pdid_' + index).removeClass('colWhite');
				$event.currentTarget.className = "maintip"
			},
			// 公告列表
			handgg() {
				this.$postcn('tongji/homeAnnouncement', {
					p: 1,
					pcount: 6
				}, this).then((res) => {
					if (res.data.code == 200) {
						this.gglist = res.data.data.data
					} else {
						this.$message({
							type: 'error',
							message: '数据错误'
						});
					}
				})
			},
			// 浏览历史
			handhistory() {
				setTimeout(() => {
					if (this.$refs.loginIndex.loginFlag == false) {
						this.$postcn('partshome/browsingHistory', {
							p: 1,
							pcount: 4
						}, this).then((res) => {
							if (res.data.code == 200) {
								this.hislist = res.data.data.data
							} else {
								this.$message({
									type: 'error',
									message: '数据错误'
								});
							}
						})
					} else if (this.$refs.loginIndex.loginFlag == true) {
						//未登录
						this.$postcn('partshome/browsingLogged', {
							p: 1,
							pcount: 4
						}, this).then((res) => {
							if (res.data.code == 200) {
								this.hislist = res.data.data.data
							} else {
								this.$message({
									type: 'error',
									message: '数据错误'
								});
							}
						})

					}
				}, 2000)
				//已登录
			},
			// 猜你喜欢
			handlike() {
				this.$postcn('partshome/guessLike', {
					p: 1,
					pcount: 3
				}, this).then((res) => {
					if (res.status == 200) {
						this.likelist = res.data.data
					} else {
						this.$message({
							type: 'error',
							message: '数据错误'
						});
					}
				})
			},
			// 最近更新的模型
			handNewcate() {
				this.$postcn('/partshome/newProduct', {
					p: 1,
					pcount: 5
				}, this).then((res) => {
					if (res.status == 200) {
						this.Ginfo = res.data.data.data
					} else {
						this.$message({
							type: 'error',
							message: '数据错误'
						});
					}
				})
			},
			jumpurl(id,Ctype) {
				let routeData;
				if(Ctype==1){
					routeData = this.$router.resolve({
						path: "/gb/gbcont",
						query: {
							goodsid: id
						}
					})
				}else{
					routeData = this.$router.resolve({
						path: "/content",
						query: {
							goodsid: id
						}
					})
				}
				window.open(routeData.href, '_blank');
			},
			jumpcate(id, catname) {
				let routeData = this.$router.resolve({
					path: "list/catelist",
					query: {
						cateid: id,
						catname: catname
					}
				})
				window.open(routeData.href, '_blank');
			},
			//零部件分类
			partssort() {
				this.$postcn('partshome/providerCategory', {}, this).then((res) => {
					if (res.data.code == 200) {
						this.partone = res.data.data
					} else {
						this.$message({
							type: 'error',
							message: '数据错误'
						});
					}
				})
			},
			//最新加入的企业
			enterprise() {
				this.$postcn('partshome/newProvider', {
					pcount: 8
				}, this).then((res) => {
					/* console.log(res); */
					if (res.status == 200) {
						this.company = res.data.data
					} else {
						this.$message({
							type: 'error',
							message: '数据错误'
						});
					}
				})
			},
			//产品
			product() {
				this.$postcn('partshome/recommended', {}, this).then((res) => {
					if (res.status == 200) {
						this.category_list = res.data.data
					} else {
						this.$message({
							type: 'error',
							message: '数据错误'
						});
					}
				})
			},
		}
	}
	// 分类菜单悬浮效果
</script>
<style scoped>
	.barprebox {
		/* 	overflow: hidden; */
		position: relative;
	}

	.fr {
		float: right;
	}

	.txl:hover {
		color: #005dbe !important;
		;
	}

	.Cactive {
		width: 250px !important;
		z-index: 9999 !important;
		border-right: none !important;
		background: #005dbe !important;
	}

	.colWhite {
		color: #fff;
	}

	.tipRemove {
		left: 250px;
		top: 0px;
		display: block !important;
		color: #666
	}

	.pd25Left {
		padding: 0px 25px 30px 25px;
		text-align: left;
	}

	.overtitle {
		text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		/* height: 30px; */
		line-height: 20px;
	}

	.max1350 {
		max-width: 1350px;
		margin: 0px auto;
		margin-top: 10px;
	}

	.lin-h17 {
		line-height: 1.7;
	}

	.mar-lr-15 {
		margin-left: -15px;
		margin-right: -15px;
	}

	.clearfix {
		width: auto;
		height: auto;
	}

	.clearfix:after {
		content: ".";
		display: block;
		height: 0;
		clear: both;
		visibility: hidden;
		font-size: 0;
	}

	.smalltit {
		margin: 0;
		line-height: 1.5;
		color: #000;
	}

	.wpro {
		width: 262px;
	}

	.partone {
		width: 246px;
		height: 100px;
		background-image: url(../../assets/bg_gary.jpg);
		background-repeat: repeat-x;
		margin: 10px 15px;
		float: left;
		text-align: center;
		color: #fff;
	}

	.partone .partoneimg {
		margin: 8px auto 5px;
	}

	.partone span {
		display: inline-block;
		width: 100%;
		word-break: keep-all;
		/* 不换行 */
		white-space: nowrap;
		/* 不换行 */
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.partone:hover {
		/* background-image: url(../../assets/bg_gary_h.jpg); */
		cursor: pointer;
		box-shadow: inset 0px 15px 15px -15px #000, inset 15px 0px 15px -15px #000;
	}

	/* part3 */
	ul {
		list-style-type: none;
	}

	.part3one {
		width: 200px;
		height: 88px;
		margin-right: 5px;
		float: left;
		background-color: #d8dde5;
		display: table-cell;
		vertical-align: middle;
		font-size: 16px;
		color: #000000;
	}

	.a1 {
		width: 592px;
		border: 1px solid #e7e7e7;
	}

	.a4 {
		float: left;
		margin-top: 45px;
	}

	.a4 span.prev {
		float: left;
		background: url(../../assets/left.png) no-repeat;
		width: 35px;
		height: 55px;
		text-indent: -9999px;
		margin-left: -50px;
		position: absolute;
		left: 55px;
		z-index: 11;
	}

	.a4 span.next {
		float: left;
		background: url(../../assets/right.png) no-repeat;
		width: 35px;
		height: 55px;
		text-indent: -9999px;
		margin-right: -50px;
		position: absolute;
		right: 55px;
		top: 50px;
	}

	.a5 {
		width: 1310px;
		height: 160px;
		overflow: hidden;
		position: relative;
		border-top: none;
		float: left;
		margin-right: 50px;
	}

	.a5 ul li {
		float: left;
		margin: 10px 5px 0;
		padding: 8px;
	}

	.a6 {
		width: 2300px;
		position: absolute;
		top: 0;
		left: 0;
	}

	.gsname1 {
		font-size: 22px;
		line-height: 2;
		display: inline-block;
	}

	.gsname2 {
		font-size: 22px;
		line-height: 4;
		display: inline-block;
	}

	.blockInfo {
		padding: 10px 10px 20px 10px;
		text-align: center;
		display: inline-block;
		width: 252px;
		/* margin: 10px; */
		box-sizing: border-box;
		vertical-align: top;
		background-color: #fafafa;
		border: 1px solid #eaeaea;
	}

	.lookD .colDP {
		border: 1px solid #ccc;
	}

	.demo-image .blockInfo {
		margin-top: 10px;
	}

	.demo-image .blockInfo:nth-child(1),
	.demo-image .blockInfo:nth-child(2),
	.demo-image .blockInfo:nth-child(3),
	.demo-image .blockInfo:nth-child(4),
	.demo-image .blockInfo:nth-child(6),
	.demo-image .blockInfo:nth-child(7),
	.demo-image .blockInfo:nth-child(8),
	.demo-image .blockInfo:nth-child(9) {
		margin-right: 10px;
	}

	.demonstration {
		height: 25px;
		line-height: 25px;
		width: 100%;
	}

	.active {
		border-color: #1f75cf !important;
		color: #1f75cf;
	}

	.Wactive {
		width: 190PX;
		cursor: pointer;
		transform: scale(1.5, 1.5)
	}

	.partstubiao_daochuCAD {
		font-size: 16px;
		margin-right: 5px;
	}

	.limtit {
		height: 40px;
		padding-left: 25px;
		padding-top: 30px;
	}

	.limtit .fl {
		font-size: 20px;
		color: #000;
		text-align: left;
	}

	.colblue {
		color: #005dbe;
	}



	.w1060 {
		width: 1060px !important;
		height: 401px;
		overflow: hidden;
	}

	.w1060 .a,
	.part4one {
		display: block;
		float: left;
		width: 211px;
		height: 200px;
		border-left: 1px solid #f3f3f3;
		overflow: hidden;
		background-color: #fff;
		border-bottom: 1px solid #f3f3f3;
	}

	.w1060 .a:hover,
	.part4one:hover {
		background-color: #e6e6e6;
		display: block;
		float: left;
		width: 211px;
		height: 200px;
	}

	.part4one .img:hover .part4one .img {
		width: 211px;
		height: 130px;
		overflow: hidden;
		text-align: center;
		vertical-align: middle;
	}

	.part4onep {
		display: inline-block;
		width: 95%;
		word-break: keep-all;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		text-align: center;
		font-size: 14px;
		color: #000;
		margin-top: 15px;
	}

	.el-image .el-image__error {
		background-color: #fff;
	}

	@media screen and (max-width: 1360px) {
		.partone {
			width: 210px;
		}

		.blockInfo {
			width: 220px;
		}

		.a4:first-child {
			margin-left: 55px;
		}

		.a5 {
			width: 1060px;
		}

		.w1060 {
			width: 910px !important;
		}

		.w1060 .a,
		.part4one,
		.w1060 .a:hover,
		.part4one:hover {
			width: 178px;
		}
	}

	.maintip {

		z-index: 1;
		text-align: left;
		width: 250px;
		background: #fff;
		height: 41px;
		line-height: 41px;
		color: #666666;
	}

	.maintip span {
		padding-left: 20px;
	}

	.tips {
		position: absolute;
		z-index: 11;
		width: 1096px;
		min-height: 615px;
		border: 1px solid #005dbe;
		background: #fff;
		display: none;
		padding: 20px;
		overflow-y: scroll;
	}

	.panCate {
		position: relative;
		width: 250px;
		display: inline-block;
		float: left;
	}

	/* lunbo */



	.RigP1 {
		height: 75px;
	}

	.RigP1 .Rigt {
		line-height: 35px;
		text-align: left;
		padding-left: 15px;
		font-size: 14px;
		color: #666;
	}

	.RigP1 .RigLS {
		font-size: 14px;
		color: #005dbe;
		font-weight: bold;
		cursor: pointer;
	}

	.RigP2 {
		height: 105px;
	}



	.RigP3 {
		height: 200px;
		line-height: 26px;
		text-align: left;
		padding: 0px 40px 0px 15px;
		font-size: 12px;
	}



	.RigP1,
	.RigP2,
	.RigP3 {
		background: #FFFFFF;
	}

	.RigP2,
	.RigP3 {
		margin-top: 10px;
	}


	.brandP {
		background-color: #FFFFFF;
		margin-top: 20PX;
		padding: 10px 25px;

	}


	.brandP .inlinI {
		display: inline-block;
		border: 1px solid #aeaeae;
		width: 221px;
		height: 60px;
	}


	.icon-gonggao {
		vertical-align: middle;
		margin-right: 5px;
	}

	.brandT {
		text-align: left;
		margin-top: 5px;
		font-weight: bold;
		font-size: 18PX;
	}

	.icon-gonggao {
		font-size: 18px;
	}



	.lookD .colDP span,
	.lookD .colDP .coldS {
		height: 150px;
		display: block;
	}

	.lookD .colDP .coldS {
		padding-left: 0;
	}

	.lookD .colDP span .el-image {
		width: 100%;
		height: 150PX;
	}

	.lookD .colDP span img {
		/* width: 120px;
		     height: 120px;
		     padding: 10px; */
		width: 100%;
		height: 150px;
	}

	.lookD .colDPimg {
		text-align: center;
		font-size: 14px;
		line-height: 25px;
	}

	.lookD .colDPimgR {
		text-align: left;
		padding-left: 10px;
		line-height: 20px;
		margin-top: 15px;
		padding-right: 38px;
	}

	.lin-h41 {
		height: 41px;
		line-height: 41px;
	}
</style>
<style>
	
	.inlinI .el-image__inner{
		width: 100%!important;
		height: 100%!important;
	}
	.el-carousel__item h3 {
		color: #475669;
		font-size: 18px;
		opacity: 0.75;
		line-height: 300px;
		margin: 0;
	}

	.swiper1 .el-carousel__container {
		height: 400px;
	}
    .swiper1 .el-carousel__indicators{
		display: block;
	}
	/* 当只有一张图是左右轮播箭头隐藏 */
	.swiper1 .el-carousel__arrow--left,
	.swiper1 .el-carousel__arrow--right {
		display: none;
	}

	.brandP .el-col {
		border-radius: 0px;
	}

	.brandP .el-col:nth-child(4) {
		margin-right: 0px;
	}

	.brandP .el-row {
		margin-top: 10px;
	}

	.RigP3 .el-link.el-link--default {
		color: #666;
		white-space: nowrap;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
		overflow: hidden;
	}

	.RigP2 .el-tab-pane {
		padding: 0px 40px;
		text-align: left;
		line-height: 25px;
	}

	.RigP2 .el-tabs__item.is-active,
	.RigP3 .el-link.el-link--default:hover {
		color: #005dbe;
	}

	.RigP2 .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
		border-bottom-color: #fff;
		background: #005dbe;
		color: #fff;
	}

	.RigP2 .el-link.el-link--default,
	.goodsHover .el-link.el-link--default {
		color: #666;
	}

	.RigP2 .el-tabs__header {
		margin: 0 0 5px;
	}

	.tips .el-col {
		line-height: 22px;
		text-align: left;
		margin-bottom: 15px;
	}

	.tips .el-link.el-link--default {
		margin-right: 12px;
	}

	.swiper1 .el-carousel__item:nth-child(2n) {
		background-color: #ffffff !important;
	}

	.swiper1 .el-carousel__item:nth-child(2n+1) {
		background-color: #ffffff!important;
	}

	.limtit .fr .el-link {
		margin: 0 10px;
	}

	.limtit .fr .el-link:last-child {
		margin-right: 0;
	}

	.overtitleOne>i {
		font-size: 22px;
		vertical-align: middle;
	}
  .swiper1 .el-link.el-link--default:hover{
	   color: #FFFFFF!important;
   }
   .swiper1 .el-link.el-link--default:after, .el-link.el-link--primary.is-underline:hover:after, .el-link.el-link--primary:after{
	color:#FFFFFF !important;  
   }
	/* .icon-Icon_zhixianceliang,.icon-mada,.icon-moxing,.icon-zhoucheng,.icon-lianzhouqi,.icon-yunshujixie,.icon-guangxue,
	.icon-jingujian_huaban,.icon-guancaijiqita,.icon-mianban,.icon-door,.icon-danhuang,.icon-guding,.icon-lei-xiangjiaozhipin,
	.icon-citie{
		
	} */

	.el-image__error {
		content: url(https://www.mfcad.cn/image/loading/384180.jpg);
		display: block;
		background-color: #fff;
		object-fit: contain
	}
	
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue